module.exports = __webpack_public_path__ + "static/media/Alexey.40613cc8.jpg";